import * as React from "react"
import { X } from "lucide-react"
import { Badge } from "./badge"
import { Input } from "./input"

interface MultiSelectProps {
  value: string[]
  onChange: (value: string[]) => void
  options?: string[]
  placeholder?: string
}

export function MultiSelect({ value, onChange, options = [], placeholder }: MultiSelectProps) {
  const [inputValue, setInputValue] = React.useState("")

  const commitInput = () => {
    if (inputValue.trim() && !value.includes(inputValue.trim())) {
      onChange([...value, inputValue.trim()])
      setInputValue("")
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" && inputValue.trim()) {
      e.preventDefault()
      commitInput()
    } else if (e.key === "Backspace" && !inputValue && value.length > 0) {
      onChange(value.slice(0, -1))
    }
  }

  const handleBlur = () => {
    commitInput()
  }

  const removeValue = (item: string) => {
    onChange(value.filter((v) => v !== item))
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2 mb-2">
        {value.map((item) => (
          <Badge key={item} variant="secondary" className="gap-1">
            {item}
            <button
              type="button"
              onClick={() => removeValue(item)}
              className="ml-1 hover:bg-almost-black/20 rounded-full"
            >
              <X className="h-3 w-3" />
            </button>
          </Badge>
        ))}
      </div>
      <Input
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        placeholder={placeholder || "Type and press Enter to add"}
      />
      {options.length > 0 && (
        <div className="text-xs text-almost-black/60">
          Suggestions: {options.filter(opt => !value.includes(opt)).slice(0, 5).join(", ")}
        </div>
      )}
    </div>
  )
}
